export class CommonWithCodeError extends Error {
  code?: string;

  constructor(error: unknown) {
    super((error as Error).message);
    this.code = (error as { code: string }).code || 'UNKNOWN_ERROR';
    this.name = 'CommonWithCodeError';
  }
}

export type CommonIdxPageProps = Promise<{ idx: string; lng: string }>;
export type CommonCodePageProps = Promise<{ code: string; lng: string }>;

export type CommonLngPageProps = Promise<{ lng: string }>;

export interface ICommonImage {
  idx: string;
  path: string;
  mimetype: string;
  url: string;
}
